module.exports = __webpack_public_path__ + "media/images/step_05-09f4c651b4db59bfa4760f07743c1a1d.gif";